/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiUTMMappingType;
(function (ApiUTMMappingType) {
    ApiUTMMappingType["UTM_MAPPING_TYPE_UNSPECIFIED"] = "UTMMappingTypeUnspecified";
    ApiUTMMappingType["UTM_MAPPING_TYPE_PARAM"] = "UTMMappingTypeParam";
    ApiUTMMappingType["UTM_MAPPING_TYPE_ALIAS_SOURCE"] = "UTMMappingTypeAliasSource";
})(ApiUTMMappingType || (ApiUTMMappingType = {}));
export function ApiUTMMappingTypeFromJSON(json) {
    return ApiUTMMappingTypeFromJSONTyped(json, false);
}
export function ApiUTMMappingTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiUTMMappingTypeToJSON(value) {
    return value;
}
